import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

class Modal extends React.PureComponent {
  constructor(props) {
    super(props);

    this.el = document.createElement('div');
  }

  componentDidMount() {
    const { root } = this.props;
    const {
      document: { documentElement },
      pageYOffset,
    } = window;
    documentElement.style.position = 'fixed';
    this.scrollTop = pageYOffset;
    documentElement.style.top = `-${this.scrollTop}px`;
    root?.appendChild(this.el);
  }

  componentWillUnmount() {
    const { root } = this.props;
    const { documentElement } = window.document;
    documentElement.style.position = '';
    documentElement.style.top = '';
    window.scroll(0, this.scrollTop);
    root.removeChild(this.el);
  }

  render() {
    const { children, shadow, className } = this.props;
    const modal = (
      <StyledOverlay className={className}>
        {shadow && <StyledShadow />}
        {children}
      </StyledOverlay>
    );

    return ReactDOM.createPortal(modal, this.el);
  }
}

Modal.defaultProps = {
  shadow: true,
  root: document.getElementById('modals'),
  className: '',
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  shadow: PropTypes.bool,
  root: PropTypes.node,
  className: PropTypes.string,
};

const StyledOverlay = styled.div`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1300;
  position: fixed;
`;

const StyledShadow = styled.div`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  position: fixed;
  touch-action: none;
  background-color: rgba(0, 0, 0, 0.75);
  -webkit-tap-highlight-color: transparent;
`;

export default Modal;
